/* eslint-disable jira/filename-case */
import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type {
	State,
	IssueTypeModifiableProps,
	IssueTypeWithPinnedFields,
} from './IssueType.types.tsx';
import { createIssueType } from './createIssueType.tsx';
import { clearIssueTypesStore } from './clearIssueTypesStore.tsx';
import { deleteIssueType } from './deleteIssueType.tsx';
import { fetchAllIssueTypes } from './fetchAllIssueTypes.tsx';
import { fetchIssueTypesForProjects } from './fetchIssueTypesForProjects.tsx';
import {
	fetchPinnedFieldsForType,
	togglePinnedField,
	updatePinnedFields,
} from './togglePinnedField.tsx';
import { populateIssueTypes } from './ActionspopulateIssueTypes.types.tsx';
import { updateIssueType } from './updateIssueType.tsx';

export const actions: {
	fetchAllIssueTypes: () => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	fetchIssueTypesForProjects: (
		projectIds: string[],
	) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	fetchPinnedFieldsForType: ({
		issueTypeId,
		projectId,
	}: {
		issueTypeId: string;
		projectId: string;
	}) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	updateIssueType: (
		issueTypeId: string,
		projectId: string,
		update: IssueTypeModifiableProps & {
			avatarUrl?: string;
		},
	) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	createIssueType: (
		projectId: string,
		data: IssueTypeModifiableProps,
	) => ({
		setState,
		getState,
		dispatch,
	}: StoreActionApi<State>) => Promise<IssueTypeWithPinnedFields>;
	deleteIssueType: (
		issueTypeId: string,
		projectId: string,
	) => ({ dispatch }: StoreActionApi<State>) => Promise<void>;
	populateIssueTypes: ({
		issueTypes,
	}: {
		issueTypes: (IssueTypeModifiableProps & {
			id: string;
			entityId: string;
			hierarchyLevel: number;
			avatarUrl: string;
			operation: {
				deletable: boolean;
				editable: boolean;
			};
		} & {
			pinnedFields?: FieldKey[];
		} & {
			projectId: string;
		})[];
	}) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	togglePinnedField: ({
		issueTypeId,
		fieldKey,
	}: {
		issueTypeId: string;
		fieldKey: FieldKey;
	}) => ({ getState, dispatch }: StoreActionApi<State>) => Promise<void>;
	updatePinnedFields: ({
		issueTypeId,
		pinnedFields,
	}: {
		issueTypeId: string;
		pinnedFields: FieldKey[];
	}) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>;
	clearIssueTypesStore: () => ({ setState }: StoreActionApi<State>) => void;
} = {
	fetchAllIssueTypes,
	fetchIssueTypesForProjects,
	fetchPinnedFieldsForType,
	updateIssueType,
	createIssueType,
	deleteIssueType,
	populateIssueTypes,
	togglePinnedField,
	updatePinnedFields,
	clearIssueTypesStore,
};
